interface UseKeydownEscKey {
  isOpen: boolean
  onClose: () => void
}

export const useKeydownEscKey = ({ isOpen, onClose }: UseKeydownEscKey) => {
  const onKeydown = (
    event:
      | globalThis.KeyboardEvent
      | React.KeyboardEvent<HTMLElement>
      | React.KeyboardEvent<Element>
  ) => {
    const isEscKey = event.keyCode === 27
    let flag = false

    if (isEscKey && isOpen) {
      onClose()
      flag = true
    }

    if (flag) {
      event.stopPropagation()
      event.preventDefault()
    }
  }

  return {
    onKeydown,
  }
}
